module.exports = __webpack_public_path__ + "img/about-banner.7670f65b.jpg";